import * as React from 'react';
import { SVGIconRender } from './SVGIconRender';

interface IconProps {
  color?: string;
  size?: string;
  bgFillColor?: string;
}

const TotalTimeLogged = ({ color = 'black', bgFillColor = 'black', size = 'md' }: IconProps) => {
  return (
    <SVGIconRender
          size={size}
          color={color}
          viewBox="0 0 57 57"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="28.5"
            cy="28.5"
            r="28.5"
            fill="#FFCFF2"
            fill-opacity="0.5"
          />
          <path
            d="M26.4993 16.5H31.4993"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M36.071 23.1788C39.976 27.0838 39.976 33.4163 36.071 37.3213C32.166 41.2263 25.8335 41.2263 21.9285 37.3213C18.0235 33.4163 18.0235 27.0838 21.9285 23.1788C25.8335 19.2737 32.166 19.2737 36.071 23.1788"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M28.9995 20.25V16.5"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M29.0063 28.375C27.9638 28.375 27.1238 29.215 27.1238 30.25C27.1238 31.285 27.9638 32.125 28.9988 32.125C30.0338 32.125 30.8738 31.285 30.8738 30.25C30.8813 29.215 30.0413 28.375 29.0063 28.375"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M30.3274 28.9213L32.7486 26.5"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M38.5742 20.6748L36.0742 23.1748"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M37.324 19.4248L39.824 21.9248"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M19.428 20.6787L21.928 23.1787"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M18.178 21.9287L20.678 19.4287"
            stroke="#323232"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </SVGIconRender>
  );
};

export default TotalTimeLogged;
